import { Image } from '@packages/shared/src/ui/Image/Image';
import { getFragmentData, type FragmentType } from '@packages/gql/generated/shopping';
import { VariationIconFragmentFragmentDoc } from '@packages/gql/generated/shopping/VariationIconFragmentFragmentDoc';
import { useResponsiveAkamaiTemplate } from '../../hooks/useResponsiveAkamaiTemplate/useResponsiveAkamaiTemplate';

const IMAGESIZEBUTTON = 24;

/* GraphQL */ `
  fragment VariationIconFragment on ProductDimensionValue {
    rgb
    image
  }
`;

export type VariationIconProps = {
  data: FragmentType<typeof VariationIconFragmentFragmentDoc>;
  /**
   * the size of the image Tile
   */
  imageSize: 'BUTTON' | 'DIALOG';
};

/**
 * The `VariationIcon` conponent is used to display an image for the selected dimension,
 * either for the `VariationRow` inside as part of the dialog or in the `SelectionDimension` as a button
 * */
export const VariationIcon = ({ data, imageSize }: VariationIconProps) => {
  const { rgb, image } = getFragmentData(VariationIconFragmentFragmentDoc, data);

  const { templateName, imageDimensions } = useResponsiveAkamaiTemplate('variationSelect');
  const IMAGESIZE = imageSize === 'BUTTON' ? IMAGESIZEBUTTON : imageDimensions.height;

  return (
    <div
      className={`flex-[0_0_${IMAGESIZE}px] overflow-hidden rounded-full h-[${IMAGESIZE}px] w-[${IMAGESIZE}px] ${rgb ? `bg-color-[#${rgb}]` : 'none'} border-color-grey border`}
    >
      {image && (
        <Image
          role="presentation"
          src={imageSize === 'DIALOG' ? `${image}?${templateName}` : image}
          alt=""
          width={IMAGESIZE}
          height={IMAGESIZE}
        />
      )}
    </div>
  );
};
